import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Axios from "axios";
import { API_URL } from "config";
import { RootState } from "store/rootReducer";
import { ActiveFilter, Filter, FiltersState } from "./types";

const initialState: FiltersState = {
  filters: [],
  activeFiltersCount: 0,
  activeFilters: [],
  openedFilter: "",
  maxPrice: 10000,
  initialLoad: false,
};

const filters = createSlice({
  name: "filtersSlice",
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<Filter[]>) {
      state.filters = action.payload;
    },
    setMaxPrice(state, action: PayloadAction<number>) {
      state.maxPrice = action.payload;
    },
    setActiveFiltersCount(state, action: PayloadAction<number>) {
      state.activeFiltersCount = action.payload;
    },
    setActiveFilters(state, action: PayloadAction<ActiveFilter[]>) {
      state.activeFilters = action.payload;
    },
    setOpenedFilter(state, action: PayloadAction<string>) {
      state.openedFilter = action.payload;
    },
    setInitialLoad(state, action: PayloadAction<boolean>) {
      state.initialLoad = action.payload;
    },
  },
});
export const {
  setFilters,
  setActiveFiltersCount,
  setActiveFilters,
  setOpenedFilter,
  setMaxPrice,
  setInitialLoad,
} = filters.actions;

export const selectFilters = (state: RootState) => state.filters.filters;
export const selectMaxPrice = (state: RootState) => state.filters.maxPrice;

export const selectActiveFiltersCount = (state: RootState) =>
  state.filters.activeFiltersCount;
export const selectActiveFilters = (state: RootState) =>
  state.filters.activeFilters;
export const selectOpenedFilter = (state: RootState) =>
  state.filters.openedFilter;
export const selectInitialLoad = (state: RootState) =>
  state.filters.initialLoad;

export default filters.reducer;
